(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[915],{

/***/ 57952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[doctorId]",
      function () {
        return __webpack_require__(64393);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 40202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ EllipsisTextStyle; },
/* harmony export */   "Sk": function() { return /* binding */ LineClampTextStyled; },
/* harmony export */   "kM": function() { return /* binding */ SelectableText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  ",
        ";\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-user-select: text;\n  user-select: text;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var EllipsisTextStyle = "\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: keep-all;\n  ";
var LineClampTextStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9616346d-0"
})(_templateObject(), function(param) {
    var lineNumber = param.lineNumber;
    return "-webkit-line-clamp: ".concat(lineNumber);
}, function(param) {
    var isSelectable = param.isSelectable;
    return isSelectable && "\n    -webkit-user-select: text;\n    user-select: text;\n  ";
});
var SelectableText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9616346d-1"
})(_templateObject1());


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleLog = function(_e) {
            var evaluatedPayload = typeof payload === "function" ? payload() : payload;
            log({
                eventName: eventName,
                payload: evaluatedPayload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log,
        enabled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 99529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DeeplinkLoggerEventName; }
/* harmony export */ });
var DeeplinkLoggerEventName;
(function(DeeplinkLoggerEventName) {
    DeeplinkLoggerEventName["ClickCtaButton"] = "click_cta_button";
    DeeplinkLoggerEventName["ImpressionQrFloating"] = "impression_qr_floating";
    DeeplinkLoggerEventName["ClickCtaText"] = "click_cta_text";
})(DeeplinkLoggerEventName || (DeeplinkLoggerEventName = {}));


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ useSearchKoreaAddressV2Query; },
/* harmony export */   "Yx": function() { return /* binding */ useDoctorReviewMetricQuery; },
/* harmony export */   "dr": function() { return /* binding */ useGetHospitalByIdQuery; },
/* harmony export */   "hh": function() { return /* binding */ useGetAddressByLocationQuery; },
/* harmony export */   "nR": function() { return /* binding */ useGetTotalReviewCountWithAverageRatingByPublicIdQuery; },
/* harmony export */   "xK": function() { return /* binding */ useGetUserAddressesQuery; }
/* harmony export */ });
/* unused harmony exports GetHospitalByIdDocument, DoctorReviewMetricDocument, GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery, GetTotalReviewCountWithAverageRatingByPublicIdDocument, GetAddressByLocationDocument, GetUserAddressesDocument, SearchKoreaAddressV2Document, HospitalExternalPostDocument, useHospitalExternalPostQuery */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetHospitalByIdDocument = "\n    query GetHospitalById($publicId: String!) {\n  getHospitalByPublicId(publicId: $publicId) {\n    id\n    name\n    isBookable\n    isTodayBookable\n    partnershipTemplate\n    profileImages {\n      url\n      isRepresentative\n    }\n    badges\n    naverPlaceDetail {\n      hashtags\n      treatmentMenus {\n        treatmentName\n        price\n      }\n    }\n    temporaryHolidaysNotice\n    temporaryHolidays\n    todayDuty {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n      operatingStatus\n    }\n    duties {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n    }\n    departmentsV2 {\n      departmentId\n      departmentName\n    }\n    departmentGroups {\n      averageRating\n      departmentGroupId\n      departmentGroupName\n      departmentGroupIconUrl\n      tags\n    }\n    nonBenefitDiagnosisPrices {\n      middleCategoryName\n      minPrice\n      maxPrice\n    }\n    longitude\n    latitude\n    jibunAddress\n    roadAddress\n    detailAddress\n    directionGuidance\n    parkingInformation\n    isFreeParking\n    tel\n    viewCount\n    introduction\n    regionByDepth {\n      siDoName\n      siGunGuName\n      eupMyeonDongName\n    }\n    treatments {\n      id\n      name\n    }\n    hospitalAdBanners {\n      displayDiscount\n      displayPrice\n      id\n      thumbnailImageUrl\n      title\n      url\n      hospitalId\n    }\n    hospitalSurgeries {\n      surgeryCount\n      surgeryName\n      badges\n      id\n    }\n    doctors {\n      id\n      publicId\n      hospitalId\n      isAbsent\n      name\n      displayName\n      medicineType\n      gender\n      profileImagePath\n      contractType\n      departmentGroups {\n        departmentGroupId\n        departmentGroupName\n        departmentGroupIconUrl\n        averageRating\n      }\n      professionalDepartmentsV2 {\n        departmentId\n        departmentName\n        departmentCode\n      }\n      careers {\n        careerType\n        content\n        id\n      }\n      reviewMetric {\n        averageRating\n        totalCount\n        groupByDiagnosisType {\n          count\n          diagnosisType\n          diagnosisTypeId\n          name\n        }\n        groupByRating {\n          count\n          rating\n        }\n      }\n      partnershipStatus\n    }\n    topRatedDoctorReviews(size: 3) {\n      content\n      createdAt\n      id\n      isPrivate\n      likeCount\n      maskedHolderName\n      rating\n      targetCategoryName\n      title\n      isBlocked\n      isLiked\n      comments {\n        content\n        createdAt\n        id\n        isBlocked\n        reviewCommentHolder {\n          id\n          name\n          profileImageUrl\n        }\n      }\n      reviewContext {\n        reviewReceiver {\n          id\n          name\n        }\n      }\n      tags {\n        id\n        reviewId\n        tag {\n          tagId\n          text\n        }\n        tagId\n      }\n    }\n  }\n}\n    ";
var useGetHospitalByIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetHospitalById",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables), options);
};
useGetHospitalByIdQuery.getKey = function(variables) {
    return [
        "GetHospitalById",
        variables
    ];
};
useGetHospitalByIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables, options);
};
var DoctorReviewMetricDocument = "\n    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {\n  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {\n    totalCount\n    averageRating\n    groupByRating {\n      count\n      rating\n    }\n    groupByDiagnosisType {\n      diagnosisType\n      diagnosisTypeId\n      name\n      count\n    }\n  }\n}\n    ";
var useDoctorReviewMetricQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "DoctorReviewMetric",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables), options);
};
useDoctorReviewMetricQuery.getKey = function(variables) {
    return [
        "DoctorReviewMetric",
        variables
    ];
};
useDoctorReviewMetricQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables, options);
};
var GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = "\n    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {\n  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {\n    hospital {\n      name\n    }\n    doctor {\n      name\n      medicineType\n    }\n    booking {\n      status\n    }\n    diagnosis {\n      status\n    }\n    bookingId\n    targetDate\n    targetDateDisplayText\n    detailSymptom\n    name\n    registrationNumber\n    address\n    detailAddress\n  }\n}\n    ";
var useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables), options);
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = function(variables) {
    return [
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ];
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables, options);
};
var GetTotalReviewCountWithAverageRatingByPublicIdDocument = "\n    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {\n  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {\n    averageRating\n    totalCount\n  }\n}\n    ";
var useGetTotalReviewCountWithAverageRatingByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables), options);
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = function(variables) {
    return [
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ];
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables, options);
};
var GetAddressByLocationDocument = "\n    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {\n  getAddressByLocation(longitude: $longitude, latitude: $latitude) {\n    detailAddress\n    jibunAddress\n    roadAddress\n    sido\n    zipCode\n    sigungu\n    dongLi\n  }\n}\n    ";
var useGetAddressByLocationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetAddressByLocation",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables), options);
};
useGetAddressByLocationQuery.getKey = function(variables) {
    return [
        "GetAddressByLocation",
        variables
    ];
};
useGetAddressByLocationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables, options);
};
var GetUserAddressesDocument = "\n    query GetUserAddresses {\n  getUserAddresses {\n    userAddressId\n    userId\n    alias\n    roadAddress\n    oldAddress\n    detailAddress\n    addressType\n    location {\n      latitude\n      longitude\n    }\n    zipCode\n    deliveryComment\n    frontDoorPassword\n    isDefault\n  }\n}\n    ";
var useGetUserAddressesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables), options);
};
useGetUserAddressesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ];
};
useGetUserAddressesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables, options);
};
var SearchKoreaAddressV2Document = "\n    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {\n  searchKoreaAddressV2(request: $request) {\n    centroidLatitude\n    centroidLongitude\n    displayName\n    regionCode\n    regionName\n  }\n}\n    ";
var useSearchKoreaAddressV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchKoreaAddressV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables), options);
};
useSearchKoreaAddressV2Query.getKey = function(variables) {
    return [
        "SearchKoreaAddressV2",
        variables
    ];
};
useSearchKoreaAddressV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables, options);
};
var HospitalExternalPostDocument = "\n    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {\n  hospitalExternalPost(\n    hospitalPublicId: $hospitalPublicId\n    size: $size\n    pivotId: $pivotId\n  ) {\n    totalCount\n    items {\n      id\n      title\n      content\n      postedAt\n      url\n    }\n  }\n}\n    ";
var useHospitalExternalPostQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "HospitalExternalPost",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables), options);
};
useHospitalExternalPostQuery.getKey = function(variables) {
    return [
        "HospitalExternalPost",
        variables
    ];
};
useHospitalExternalPostQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables, options);
};


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                })
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ Review; },
/* harmony export */   "Fj": function() { return /* binding */ EReviewType; },
/* harmony export */   "IE": function() { return /* binding */ ReviewComment; },
/* harmony export */   "R": function() { return /* binding */ ReviewDiagnosisDoctor; },
/* harmony export */   "Vj": function() { return /* binding */ ReviewTag; },
/* harmony export */   "XV": function() { return /* binding */ ReviewTagExposure; },
/* harmony export */   "fr": function() { return /* binding */ ReviewTargetType; }
/* harmony export */ });
/* unused harmony exports MedicineType, ReviewDiagnosis */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27805);


var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["DOCTOR"] = "DOCTOR";
    ReviewTargetType["PHARMACY"] = "PHARMACY";
})(ReviewTargetType || (ReviewTargetType = {}));
var EReviewType;
(function(EReviewType) {
    EReviewType["NORMAL"] = "NORMAL";
    EReviewType["BEST"] = "BEST";
})(EReviewType || (EReviewType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var Review = /*#__PURE__*/ function() {
    "use strict";
    function Review(review) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Review);
        this.review = review;
    }
    var _proto = Review.prototype;
    _proto.shouldNotDisplayed = function shouldNotDisplayed(currentUserId) {
        if (!this.isPrivate) {
            return false;
        }
        return Number(currentUserId) !== Number(this.userId);
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Review, [
        {
            key: "id",
            get: function get() {
                return this.review.id;
            }
        },
        {
            key: "isPrivate",
            get: function get() {
                return this.review.isPrivate;
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.review.userId;
            }
        },
        {
            key: "isLiked",
            get: function get() {
                return this.review.isLiked;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.review.title;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.review.content;
            }
        },
        {
            key: "writer",
            get: function get() {
                return this.review.writer;
            }
        },
        {
            key: "rating",
            get: function get() {
                return this.review.rating;
            }
        },
        {
            key: "comment",
            get: function get() {
                return this.review.comment;
            }
        },
        {
            key: "likeCount",
            get: function get() {
                return this.review.likeCount;
            }
        },
        {
            key: "tags",
            get: function get() {
                return this.review.tags;
            }
        },
        {
            key: "price",
            get: function get() {
                return this.review.price;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.review.createdAt;
            }
        },
        {
            key: "diagnosisCategoryName",
            get: function get() {
                return this.review.diagnosisCategoryName;
            }
        },
        {
            key: "doctor",
            get: function get() {
                return this.review.doctor;
            }
        }
    ]);
    return Review;
}();
var ReviewTag = /*#__PURE__*/ function() {
    "use strict";
    function ReviewTag(tag) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewTag);
        this.tag = tag;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewTag, [
        {
            key: "reviewId",
            get: function get() {
                return this.tag.reviewId;
            }
        },
        {
            key: "tagId",
            get: function get() {
                return this.tag.tagId;
            }
        },
        {
            key: "text",
            get: function get() {
                return this.tag.text;
            }
        }
    ]);
    return ReviewTag;
}();
var ReviewComment = /*#__PURE__*/ function() {
    "use strict";
    function ReviewComment(reviewComment) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewComment);
        this.reviewComment = reviewComment;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewComment, [
        {
            key: "createdAt",
            get: function get() {
                return this.reviewComment.createdAt;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.reviewComment.content;
            }
        }
    ]);
    return ReviewComment;
}();
var ReviewDiagnosis = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ReviewDiagnosis(reviewDiagnosis) {
        _class_call_check(this, ReviewDiagnosis);
        this.reviewDiagnosis = reviewDiagnosis;
    }
    _create_class(ReviewDiagnosis, [
        {
            key: "doctor",
            get: function get() {
                return this.reviewDiagnosis.doctor;
            }
        }
    ]);
    return ReviewDiagnosis;
}()));
var ReviewDiagnosisDoctor = /*#__PURE__*/ function() {
    "use strict";
    function ReviewDiagnosisDoctor(reviewDiagnosisDoctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewDiagnosisDoctor);
        this.reviewDiagnosisDoctor = reviewDiagnosisDoctor;
    }
    var _proto = ReviewDiagnosisDoctor.prototype;
    _proto.getDoctorDisplayName = function getDoctorDisplayName() {
        if (this.medicineType === MedicineType.OrientalDoctor) {
            return "".concat(this.name, " 한의사");
        }
        return "".concat(this.name, " 의사");
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewDiagnosisDoctor, [
        {
            key: "id",
            get: function get() {
                return this.reviewDiagnosisDoctor.id;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.reviewDiagnosisDoctor.medicineType;
            }
        },
        {
            key: "name",
            get: function get() {
                return this.reviewDiagnosisDoctor.name;
            }
        },
        {
            key: "profile",
            get: function get() {
                return this.reviewDiagnosisDoctor.profile;
            }
        }
    ]);
    return ReviewDiagnosisDoctor;
}();
var ReviewTagExposure;
(function(ReviewTagExposure) {
    ReviewTagExposure["ALWAYS"] = "ALWAYS";
    ReviewTagExposure["POSITIVE"] = "POSITIVE";
    ReviewTagExposure["NEGATIVE"] = "NEGATIVE";
    ReviewTagExposure["NONE"] = "NONE";
})(ReviewTagExposure || (ReviewTagExposure = {}));


/***/ }),

/***/ 64393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83651);
/* harmony import */ var _views_doctor_detail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60921);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55351);
// PageDescription: 의사 상세 페이지




var DoctorDetailPage = function(param) {
    var client = param.client, seoData = param.seoData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            seoData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: seoData.title,
                description: seoData.description,
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: seoData.keywords
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_doctor_detail__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDetailTemplate */ .kk, {
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (DoctorDetailPage);
DoctorDetailPage.Layout = _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ hooks_useAirbridgeDynamicLink; }
});

// UNUSED EXPORTS: useDebounceWithLoading

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/shared/hooks/useAirbridgeDynamicLink.ts










var AIRBRIDGE_PARAM_PREFIX = "ab_";
var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var formatOptionsForLogging = function(options) {
    return Object.fromEntries(Object.entries(options).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            "".concat(AIRBRIDGE_PARAM_PREFIX).concat(key),
            typeof value === "number" ? value.toString() : value, 
        ];
    }));
};
var useAirbridgeDynamicLink = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "web_organic", initOptions = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var getDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getDynamicLink */.Z.getDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, initOptions, options), linkType);
    };
    var getTrackingParams = function() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getTrackingParams */.Z.getTrackingParams(linkType);
    };
    var createTrackingLinkAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(channel, options) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    airbridge/* default.createTrackingLinkAsync */.Z.createTrackingLinkAsync(channel, options)
                ];
            });
        });
        return function createTrackingLinkAsync(channel, options) {
            return _ref.apply(this, arguments);
        };
    }();
    var logToFirebase = function(eventName, options) {
        var pageName = (0,logger/* getPageName */.j0)(router);
        var sanitizedEventName = sanitizeEventName(eventName);
        var formattedOptions = formatOptionsForLogging((0,_object_spread/* default */.Z)({}, initOptions, options));
        var payload = (0,_object_spread/* default */.Z)({
            page_name: pageName
        }, formattedOptions);
        if (env/* IS_LOCAL */.Kc) {
            console.log("logger >>", (0,_object_spread/* default */.Z)({
                eventName: sanitizedEventName
            }, payload));
            return;
        }
        firebase/* default.logEventOnlyFirebase */.Z.logEventOnlyFirebase(sanitizedEventName, payload);
    };
    var navigateWithTracking = function(eventName, options) {
        var linkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        var customOptions = (0,_object_spread/* default */.Z)({}, initOptions, options);
        logToFirebase(eventName, customOptions);
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, customOptions), linkType);
    };
    return {
        navigateWithTracking: navigateWithTracking,
        getDynamicLink: getDynamicLink,
        getTrackingParams: getTrackingParams,
        logToFirebase: logToFirebase,
        createTrackingLinkAsync: createTrackingLinkAsync
    };
};
/* harmony default export */ var hooks_useAirbridgeDynamicLink = (useAirbridgeDynamicLink);

// EXTERNAL MODULE: ./src/shared/hooks/useDebounceWithLoading.ts
var useDebounceWithLoading = __webpack_require__(78974);
;// CONCATENATED MODULE: ./src/shared/hooks/index.ts





/***/ }),

/***/ 78974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useDebounceWithLoading = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), debounced = ref[0], setDebounced = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(previousValue.current, value)) {
            setIsLoading(true);
            previousValue.current = value;
        }
        var handler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            setDebounced(value);
            setIsLoading(false);
        }, delay, options);
        handler();
        return function() {
            handler.cancel();
        };
    }, [
        value,
        delay,
        options
    ]);
    return {
        debouncedValue: debounced,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounceWithLoading);


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,1498,10,5896,8391,9653,6326,7292,5679,5,1470,6409,6009,9774,2888,179], function() { return __webpack_exec__(57952); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);